import { render, staticRenderFns } from "./jicaiList.vue?vue&type=template&id=576727c4&"
import script from "./jicaiList.vue?vue&type=script&lang=js&"
export * from "./jicaiList.vue?vue&type=script&lang=js&"
import style0 from "./jicaiList.vue?vue&type=style&index=0&id=576727c4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports